import React from 'react'
import ReactPlayer from 'react-player/lib/players/FilePlayer'

import {Page, Container169, FullSizeInContainer} from './../common/StyledComponents'
import {CategoryButtons, CategoryButton, HelpAnimation, HelpAnimationContainer} from './Components'
import Settings from '../../Settings'

import bgVideo from './../../theme/vid/home-bg.mp4'

export const Home = ({
  match: {
    params: {locale},
  },
}) => {
  return (
    <Page>
      <Container169>
        {<ReactPlayer url={bgVideo} playing controls={false} loop width="100%" height="100%" />}
      </Container169>

      <CategoryButtons>
        {Settings.categories.map(category => (
          <CategoryButton
            to={`/${locale}/category/${category.key}`}
            position={category.position}
            size={category.size}
            key={category.key}
          >
            <FullSizeInContainer style={{backgroundImage: `url('${category.image}')`}} />
            <span>{category.label[locale]}</span>
          </CategoryButton>
        ))}
      </CategoryButtons>
      <HelpAnimationContainer>
        <HelpAnimation to={Settings.categories[0].position} size={Settings.categories[0].size} />
      </HelpAnimationContainer>
    </Page>
  )
}
